import React, { Component } from "react";
import Header from "../../layout/Header";
import Footer from "../../layout/Footer";
import { message, Spin, Radio, Space } from "antd";
import Bridge from "../../utils/Bridge";

export default class Roads extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,

      nod_yes_no: "",
      ride_in_a_car: "",
      eat_soup: "",
      drink_milkshake: "",
      sit_on_toilet: "",
      swallow_pills: "",
      blow_out_candle: "",
      eat_dry_food: "",
      speak_on_phone: "",
      drink_out_of_glass: "",
      eat_large_meal: "",
      sign_nam_proper: "",
      get_into_bed: "",
      roll_over_in_bed: "",
      take_shower: "",
      use_knife_and_fork: "",
      walk_around_your_home: "",
      move_a_chair: "",
      speak_in_load_room: "",
      speak_for_hours: "",
      clip_nails: "",
      walk_up_1_flight_of_stairs: "",
      walk_up_a_hill: "",
      climb_a_stepstool: "",
      give_up_from_the_floor: "",
      carry_an_object_downstairs: "",
      stand_for_hours: "",
      get_heavy_objects_off_high_shelf: "",

      total_score: 0,

      options: [
        {
          label: "Unable to perform",
          value: "0",
        },
        {
          label: "Abnormal: able to perform but with difficulty",
          value: "1",
        },
        { label: "Normal: able to perform without difficulty", value: "2" },
      ],
    };
  }
  save_road_session = () => {
    if (this.state.nod_yes_no === "" && this.state.nod_yes_no !== 0) {
      message.warning("Please select value of 'Nod yes or no' field");
      return;
    }
    if (this.state.ride_in_a_car === "" && this.state.ride_in_a_car !== 0) {
      message.warning("Please select value of 'Ride in a car' field");
      return;
    }
    if (this.state.eat_soup === "" && this.state.eat_soup !== 0) {
      message.warning("Please select value of 'Eat soup' field");
      return;
    }
    if (this.state.drink_milkshake === "" && this.state.drink_milkshake !== 0) {
      message.warning(
        "Please select value of 'Drink milkshake or smoothie' field"
      );
      return;
    }
    if (this.state.sit_on_toilet === "" && this.state.sit_on_toilet !== 0) {
      message.warning("Please select value of 'Sit on a toilet' field");
      return;
    }
    if (this.state.swallow_pills === "" && this.state.swallow_pills !== 0) {
      message.warning("Please select value of 'Swallow pills' field");
      return;
    }
    if (this.state.blow_out_candle === "" && this.state.blow_out_candle !== 0) {
      message.warning("Please select value of 'Blow out a candle' field");
      return;
    }
    if (this.state.eat_dry_food === "" && this.state.eat_dry_food !== 0) {
      message.warning("Please select value of 'Eat dry food' field");
      return;
    }
    if (this.state.speak_on_phone === "" && this.state.speak_on_phone !== 0) {
      message.warning("Please select value of 'Speak on the phone' field");
      return;
    }
    if (
      this.state.drink_out_of_glass === "" &&
      this.state.drink_out_of_glass !== 0
    ) {
      message.warning("Please select value of 'Drink out of a glass' field");
      return;
    }
    if (this.state.eat_large_meal === "" && this.state.eat_large_meal !== 0) {
      message.warning("Please select value of 'Eat a large meal' field");
      return;
    }
    if (this.state.sign_nam_proper === "" && this.state.sign_nam_proper !== 0) {
      message.warning("Please select value of 'Sign name on paper' field");
      return;
    }
    if (this.state.get_into_bed === "" && this.state.get_into_bed !== 0) {
      message.warning("Please select value of 'Get into bed' field");
      return;
    }
    if (
      this.state.roll_over_in_bed === "" &&
      this.state.roll_over_in_bed !== 0
    ) {
      message.warning("Please select value of 'Roll over in bed' field");
      return;
    }
    if (this.state.take_shower === "" && this.state.take_shower !== 0) {
      message.warning("Please select value of 'Take a shower' field");
      return;
    }
    if (
      this.state.use_knife_and_fork === "" &&
      this.state.use_knife_and_fork !== 0
    ) {
      message.warning("Please select value of 'Use a knife and fork' field");
      return;
    }
    if (
      this.state.walk_around_your_home === "" &&
      this.state.walk_around_your_home !== 0
    ) {
      message.warning("Please select value of 'Walk around your home' field");
      return;
    }
    if (this.state.move_a_chair === "" && this.state.move_a_chair !== 0) {
      message.warning("Please select value of 'Move a chair' field");
      return;
    }
    if (
      this.state.speak_in_load_room === "" &&
      this.state.speak_in_load_room !== 0
    ) {
      message.warning("Please select value of 'Speak in a loud room' field");
      return;
    }
    if (this.state.speak_for_hours === "" && this.state.speak_for_hours !== 0) {
      message.warning("Please select value of 'Speak for hours' field");
      return;
    }
    if (this.state.clip_nails === "" && this.state.clip_nails !== 0) {
      message.warning("Please select value of 'Clip nails' field");
      return;
    }
    if (
      this.state.walk_up_1_flight_of_stairs === "" &&
      this.state.walk_up_1_flight_of_stairs !== 0
    ) {
      message.warning(
        "Please select value of 'Walk up 1 flight of stairs' field"
      );
      return;
    }
    if (this.state.walk_up_a_hill === "" && this.state.walk_up_a_hill !== 0) {
      message.warning("Please select value of 'Walk up a hill' field");
      return;
    }
    if (
      this.state.climb_a_stepstool === "" &&
      this.state.climb_a_stepstool !== 0
    ) {
      message.warning("Please select value of 'Climb a stepstool' field");
      return;
    }
    if (
      this.state.give_up_from_the_floor === "" &&
      this.state.give_up_from_the_floor !== 0
    ) {
      message.warning("Please select value of 'Get up from the floor' field");
      return;
    }
    if (
      this.state.carry_an_object_downstairs === "" &&
      this.state.carry_an_object_downstairs !== 0
    ) {
      message.warning(
        "Please select value of 'Carry an object going downstairs' field"
      );
      return;
    }
    if (this.state.stand_for_hours === "" && this.state.stand_for_hours !== 0) {
      message.warning("Please select value of 'Stand for hours' field");
      return;
    }
    if (
      this.state.get_heavy_objects_off_high_shelf === "" &&
      this.state.get_heavy_objects_off_high_shelf !== 0
    ) {
      message.warning(
        "Please select value of 'Get heavy objects off a high shelf' field"
      );
      return;
    }
    let params = {
      nod_yes_no: this.state.nod_yes_no,
      ride_in_a_car: this.state.ride_in_a_car,
      eat_soup: this.state.eat_soup,
      drink_milkshake: this.state.drink_milkshake,
      sit_on_toilet: this.state.sit_on_toilet,
      swallow_pills: this.state.swallow_pills,
      blow_out_candle: this.state.blow_out_candle,
      eat_dry_food: this.state.eat_dry_food,
      speak_on_phone: this.state.speak_on_phone,
      drink_out_of_glass: this.state.drink_out_of_glass,
      eat_large_meal: this.state.eat_large_meal,
      sign_nam_proper: this.state.sign_nam_proper,
      get_into_bed: this.state.get_into_bed,
      roll_over_in_bed: this.state.roll_over_in_bed,
      take_shower: this.state.take_shower,
      use_knife_and_fork: this.state.use_knife_and_fork,
      walk_around_your_home: this.state.walk_around_your_home,
      move_a_chair: this.state.move_a_chair,
      speak_in_load_room: this.state.speak_in_load_room,
      speak_for_hours: this.state.speak_for_hours,
      clip_nails: this.state.clip_nails,
      walk_up_1_flight_of_stairs: this.state.walk_up_1_flight_of_stairs,
      walk_up_a_hill: this.state.walk_up_a_hill,
      climb_a_stepstool: this.state.climb_a_stepstool,
      give_up_from_the_floor: this.state.give_up_from_the_floor,
      carry_an_object_downstairs: this.state.carry_an_object_downstairs,
      stand_for_hours: this.state.stand_for_hours,
      get_heavy_objects_off_high_shelf:
        this.state.get_heavy_objects_off_high_shelf,
      eals_id: localStorage.getItem("ap_eals_id"),
    };
    this.setState({ loading: true });
    Bridge.roads
      .save(params)
      .then((response) => {
        if (response.data.status == "1") {
          message.success(response.data.message);
          this.setState(
            {
              nod_yes_no: "",
              ride_in_a_car: "",
              eat_soup: "",
              drink_milkshake: "",
              sit_on_toilet: "",
              swallow_pills: "",
              blow_out_candle: "",
              eat_dry_food: "",
              speak_on_phone: "",
              drink_out_of_glass: "",
              eat_large_meal: "",
              sign_nam_proper: "",
              get_into_bed: "",
              roll_over_in_bed: "",
              take_shower: "",
              use_knife_and_fork: "",
              walk_around_your_home: "",
              move_a_chair: "",
              speak_in_load_room: "",
              speak_for_hours: "",
              clip_nails: "",
              walk_up_1_flight_of_stairs: "",
              walk_up_a_hill: "",
              climb_a_stepstool: "",
              give_up_from_the_floor: "",
              carry_an_object_downstairs: "",
              stand_for_hours: "",
              get_heavy_objects_off_high_shelf: "",
              loading: false,
            },
            () => {
              setTimeout(() => {
                window.location.assign("/dashboard");
              }, 2000);
            }
          );
        } else {
          message.warning(response.data.message);
          this.setState({ loading: false });
        }
      })
      .catch((error) => {
        message.error("Please try again!!");
        this.setState({ loading: false });
      });
  };
  render() {
    return (
      <div>
        <Header />
        <div className="main-content demographics-section-wrapper">
          <div className="container">
            <div className="row">
              <div className="col-lg-11 m-auto">
                <Spin spinning={this.state.loading}>
                  <div className="demographic-single-section">
                    <a
                      href="/dashboard"
                      style={{ width: 95 }}
                      className="back-arrow"
                    >
                      <box-icon
                        name="chevron-left"
                        color="#fff"
                        style={{ position: "relative", top: 1 }}
                      ></box-icon>
                      Back
                    </a>
                    <div>
                      <div className="header">
                        <h3>ADD ROADS</h3>
                        <div className="white-block"></div>
                      </div>
                      <Spin spinning={this.state.loading}>
                        <div className="form-fields">
                          <div className="form-group">
                            <label className="mb-2 input-heading">
                              1. Nod yes or no?
                              <span className="text-danger">*</span>
                            </label>
                            <br />
                            <Radio.Group
                              onChange={(e) =>
                                this.setState({
                                  nod_yes_no: e.target.value,
                                })
                              }
                              value={this.state.nod_yes_no}
                              direction="vertical"
                            >
                              <Space direction="vertical">
                                {this.state.options.map((single, i) => {
                                  return (
                                    <Radio value={single.value} index={i}>
                                      {single.label}
                                    </Radio>
                                  );
                                })}
                              </Space>
                            </Radio.Group>
                          </div>
                          <div className="form-group">
                            <label className="mb-2 input-heading">
                              2. Ride in a car?
                              <span className="text-danger">*</span>
                            </label>
                            <br />
                            <Radio.Group
                              onChange={(e) =>
                                this.setState({
                                  ride_in_a_car: e.target.value,
                                })
                              }
                              value={this.state.ride_in_a_car}
                              direction="vertical"
                            >
                              <Space direction="vertical">
                                {this.state.options.map((single, i) => {
                                  return (
                                    <Radio value={single.value} index={i}>
                                      {single.label}
                                    </Radio>
                                  );
                                })}
                              </Space>
                            </Radio.Group>
                          </div>
                          <div className="form-group">
                            <label className="mb-2 input-heading">
                              3. Eat soup?
                              <span className="text-danger">*</span>
                            </label>
                            <br />
                            <Radio.Group
                              onChange={(e) =>
                                this.setState({
                                  eat_soup: e.target.value,
                                })
                              }
                              value={this.state.eat_soup}
                              direction="vertical"
                            >
                              <Space direction="vertical">
                                {this.state.options.map((single, i) => {
                                  return (
                                    <Radio value={single.value} index={i}>
                                      {single.label}
                                    </Radio>
                                  );
                                })}
                              </Space>
                            </Radio.Group>
                          </div>
                          <div className="form-group">
                            <label className="mb-2 input-heading">
                              4. Drink milkshake or smoothie?
                              <span className="text-danger">*</span>
                            </label>
                            <br />
                            <Radio.Group
                              onChange={(e) =>
                                this.setState({
                                  drink_milkshake: e.target.value,
                                })
                              }
                              value={this.state.drink_milkshake}
                              direction="vertical"
                            >
                              <Space direction="vertical">
                                {this.state.options.map((single, i) => {
                                  return (
                                    <Radio value={single.value} index={i}>
                                      {single.label}
                                    </Radio>
                                  );
                                })}
                              </Space>
                            </Radio.Group>
                          </div>
                          <div className="form-group">
                            <label className="mb-2 input-heading">
                              5. Sit on a toilet?
                              <span className="text-danger">*</span>
                            </label>
                            <br />
                            <Radio.Group
                              onChange={(e) =>
                                this.setState({
                                  sit_on_toilet: e.target.value,
                                })
                              }
                              value={this.state.sit_on_toilet}
                              direction="vertical"
                            >
                              <Space direction="vertical">
                                {this.state.options.map((single, i) => {
                                  return (
                                    <Radio value={single.value} index={i}>
                                      {single.label}
                                    </Radio>
                                  );
                                })}
                              </Space>
                            </Radio.Group>
                          </div>
                          <div className="form-group">
                            <label className="mb-2 input-heading">
                              6. Swallow pills?
                              <span className="text-danger">*</span>
                            </label>
                            <br />
                            <Radio.Group
                              onChange={(e) =>
                                this.setState({
                                  swallow_pills: e.target.value,
                                })
                              }
                              value={this.state.swallow_pills}
                              direction="vertical"
                            >
                              <Space direction="vertical">
                                {this.state.options.map((single, i) => {
                                  return (
                                    <Radio value={single.value} index={i}>
                                      {single.label}
                                    </Radio>
                                  );
                                })}
                              </Space>
                            </Radio.Group>
                          </div>
                          <div className="form-group">
                            <label className="mb-2 input-heading">
                              7. Blow out a candle?
                              <span className="text-danger">*</span>
                            </label>
                            <br />
                            <Radio.Group
                              onChange={(e) =>
                                this.setState({
                                  blow_out_candle: e.target.value,
                                })
                              }
                              value={this.state.blow_out_candle}
                              direction="vertical"
                            >
                              <Space direction="vertical">
                                {this.state.options.map((single, i) => {
                                  return (
                                    <Radio value={single.value} index={i}>
                                      {single.label}
                                    </Radio>
                                  );
                                })}
                              </Space>
                            </Radio.Group>
                          </div>
                          <div className="form-group">
                            <label className="mb-2 input-heading">
                              8. Eat dry food(e.g. cornbread)?
                              <span className="text-danger">*</span>
                            </label>
                            <br />
                            <Radio.Group
                              onChange={(e) =>
                                this.setState({
                                  eat_dry_food: e.target.value,
                                })
                              }
                              value={this.state.eat_dry_food}
                              direction="vertical"
                            >
                              <Space direction="vertical">
                                {this.state.options.map((single, i) => {
                                  return (
                                    <Radio value={single.value} index={i}>
                                      {single.label}
                                    </Radio>
                                  );
                                })}
                              </Space>
                            </Radio.Group>
                          </div>
                          <div className="form-group">
                            <label className="mb-2 input-heading">
                              9. Speak on the phone?
                              <span className="text-danger">*</span>
                            </label>
                            <br />
                            <Radio.Group
                              onChange={(e) =>
                                this.setState({
                                  speak_on_phone: e.target.value,
                                })
                              }
                              value={this.state.speak_on_phone}
                              direction="vertical"
                            >
                              <Space direction="vertical">
                                {this.state.options.map((single, i) => {
                                  return (
                                    <Radio value={single.value} index={i}>
                                      {single.label}
                                    </Radio>
                                  );
                                })}
                              </Space>
                            </Radio.Group>
                          </div>
                          <div className="form-group">
                            <label className="mb-2 input-heading">
                              10. Drink out of a glass?
                              <span className="text-danger">*</span>
                            </label>
                            <br />
                            <Radio.Group
                              onChange={(e) =>
                                this.setState({
                                  drink_out_of_glass: e.target.value,
                                })
                              }
                              value={this.state.drink_out_of_glass}
                              direction="vertical"
                            >
                              <Space direction="vertical">
                                {this.state.options.map((single, i) => {
                                  return (
                                    <Radio value={single.value} index={i}>
                                      {single.label}
                                    </Radio>
                                  );
                                })}
                              </Space>
                            </Radio.Group>
                          </div>
                          <div className="form-group">
                            <label className="mb-2 input-heading">
                              11. Eat a large meal?
                              <span className="text-danger">*</span>
                            </label>
                            <br />
                            <Radio.Group
                              onChange={(e) =>
                                this.setState({
                                  eat_large_meal: e.target.value,
                                })
                              }
                              value={this.state.eat_large_meal}
                              direction="vertical"
                            >
                              <Space direction="vertical">
                                {this.state.options.map((single, i) => {
                                  return (
                                    <Radio value={single.value} index={i}>
                                      {single.label}
                                    </Radio>
                                  );
                                })}
                              </Space>
                            </Radio.Group>
                          </div>
                          <div className="form-group">
                            <label className="mb-2 input-heading">
                              12. Sign name on paper?
                              <span className="text-danger">*</span>
                            </label>
                            <br />
                            <Radio.Group
                              onChange={(e) =>
                                this.setState({
                                  sign_nam_proper: e.target.value,
                                })
                              }
                              value={this.state.sign_nam_proper}
                              direction="vertical"
                            >
                              <Space direction="vertical">
                                {this.state.options.map((single, i) => {
                                  return (
                                    <Radio value={single.value} index={i}>
                                      {single.label}
                                    </Radio>
                                  );
                                })}
                              </Space>
                            </Radio.Group>
                          </div>
                          <div className="form-group">
                            <label className="mb-2 input-heading">
                              13. Get into bed?
                              <span className="text-danger">*</span>
                            </label>
                            <br />
                            <Radio.Group
                              onChange={(e) =>
                                this.setState({
                                  get_into_bed: e.target.value,
                                })
                              }
                              value={this.state.get_into_bed}
                              direction="vertical"
                            >
                              <Space direction="vertical">
                                {this.state.options.map((single, i) => {
                                  return (
                                    <Radio value={single.value} index={i}>
                                      {single.label}
                                    </Radio>
                                  );
                                })}
                              </Space>
                            </Radio.Group>
                          </div>
                          <div className="form-group">
                            <label className="mb-2 input-heading">
                              14. Roll over in bed?
                              <span className="text-danger">*</span>
                            </label>
                            <br />
                            <Radio.Group
                              onChange={(e) =>
                                this.setState({
                                  roll_over_in_bed: e.target.value,
                                })
                              }
                              value={this.state.roll_over_in_bed}
                              direction="vertical"
                            >
                              <Space direction="vertical">
                                {this.state.options.map((single, i) => {
                                  return (
                                    <Radio value={single.value} index={i}>
                                      {single.label}
                                    </Radio>
                                  );
                                })}
                              </Space>
                            </Radio.Group>
                          </div>
                          <div className="form-group">
                            <label className="mb-2 input-heading">
                              15. Take a shower?
                              <span className="text-danger">*</span>
                            </label>
                            <br />
                            <Radio.Group
                              onChange={(e) =>
                                this.setState({
                                  take_shower: e.target.value,
                                })
                              }
                              value={this.state.take_shower}
                              direction="vertical"
                            >
                              <Space direction="vertical">
                                {this.state.options.map((single, i) => {
                                  return (
                                    <Radio value={single.value} index={i}>
                                      {single.label}
                                    </Radio>
                                  );
                                })}
                              </Space>
                            </Radio.Group>
                          </div>
                          <div className="form-group">
                            <label className="mb-2 input-heading">
                              16. Use a knife and fork?
                              <span className="text-danger">*</span>
                            </label>
                            <br />
                            <Radio.Group
                              onChange={(e) =>
                                this.setState({
                                  use_knife_and_fork: e.target.value,
                                })
                              }
                              value={this.state.use_knife_and_fork}
                              direction="vertical"
                            >
                              <Space direction="vertical">
                                {this.state.options.map((single, i) => {
                                  return (
                                    <Radio value={single.value} index={i}>
                                      {single.label}
                                    </Radio>
                                  );
                                })}
                              </Space>
                            </Radio.Group>
                          </div>
                          <div className="form-group">
                            <label className="mb-2 input-heading">
                              17. Walk around your home?
                              <span className="text-danger">*</span>
                            </label>
                            <br />
                            <Radio.Group
                              onChange={(e) =>
                                this.setState({
                                  walk_around_your_home: e.target.value,
                                })
                              }
                              value={this.state.walk_around_your_home}
                              direction="vertical"
                            >
                              <Space direction="vertical">
                                {this.state.options.map((single, i) => {
                                  return (
                                    <Radio value={single.value} index={i}>
                                      {single.label}
                                    </Radio>
                                  );
                                })}
                              </Space>
                            </Radio.Group>
                          </div>
                          <div className="form-group">
                            <label className="mb-2 input-heading">
                              18. Move a chair?
                              <span className="text-danger">*</span>
                            </label>
                            <br />
                            <Radio.Group
                              onChange={(e) =>
                                this.setState({
                                  move_a_chair: e.target.value,
                                })
                              }
                              value={this.state.move_a_chair}
                              direction="vertical"
                            >
                              <Space direction="vertical">
                                {this.state.options.map((single, i) => {
                                  return (
                                    <Radio value={single.value} index={i}>
                                      {single.label}
                                    </Radio>
                                  );
                                })}
                              </Space>
                            </Radio.Group>
                          </div>
                          <div className="form-group">
                            <label className="mb-2 input-heading">
                              19. Speak in a loud room?
                              <span className="text-danger">*</span>
                            </label>
                            <br />
                            <Radio.Group
                              onChange={(e) =>
                                this.setState({
                                  speak_in_load_room: e.target.value,
                                })
                              }
                              value={this.state.speak_in_load_room}
                              direction="vertical"
                            >
                              <Space direction="vertical">
                                {this.state.options.map((single, i) => {
                                  return (
                                    <Radio value={single.value} index={i}>
                                      {single.label}
                                    </Radio>
                                  );
                                })}
                              </Space>
                            </Radio.Group>
                          </div>
                          <div className="form-group">
                            <label className="mb-2 input-heading">
                              20. Speak for hours?
                              <span className="text-danger">*</span>
                            </label>
                            <br />
                            <Radio.Group
                              onChange={(e) =>
                                this.setState({
                                  speak_for_hours: e.target.value,
                                })
                              }
                              value={this.state.speak_for_hours}
                              direction="vertical"
                            >
                              <Space direction="vertical">
                                {this.state.options.map((single, i) => {
                                  return (
                                    <Radio value={single.value} index={i}>
                                      {single.label}
                                    </Radio>
                                  );
                                })}
                              </Space>
                            </Radio.Group>
                          </div>
                          <div className="form-group">
                            <label className="mb-2 input-heading">
                              21. Clip nails?
                              <span className="text-danger">*</span>
                            </label>
                            <br />
                            <Radio.Group
                              onChange={(e) =>
                                this.setState({
                                  clip_nails: e.target.value,
                                })
                              }
                              value={this.state.clip_nails}
                              direction="vertical"
                            >
                              <Space direction="vertical">
                                {this.state.options.map((single, i) => {
                                  return (
                                    <Radio value={single.value} index={i}>
                                      {single.label}
                                    </Radio>
                                  );
                                })}
                              </Space>
                            </Radio.Group>
                          </div>
                          <div className="form-group">
                            <label className="mb-2 input-heading">
                              22. Walk up 1 flight of stairs?
                              <span className="text-danger">*</span>
                            </label>
                            <br />
                            <Radio.Group
                              onChange={(e) =>
                                this.setState({
                                  walk_up_1_flight_of_stairs: e.target.value,
                                })
                              }
                              value={this.state.walk_up_1_flight_of_stairs}
                              direction="vertical"
                            >
                              <Space direction="vertical">
                                {this.state.options.map((single, i) => {
                                  return (
                                    <Radio value={single.value} index={i}>
                                      {single.label}
                                    </Radio>
                                  );
                                })}
                              </Space>
                            </Radio.Group>
                          </div>
                          <div className="form-group">
                            <label className="mb-2 input-heading">
                              23. Walk up a hill?
                              <span className="text-danger">*</span>
                            </label>
                            <br />
                            <Radio.Group
                              onChange={(e) =>
                                this.setState({
                                  walk_up_a_hill: e.target.value,
                                })
                              }
                              value={this.state.walk_up_a_hill}
                              direction="vertical"
                            >
                              <Space direction="vertical">
                                {this.state.options.map((single, i) => {
                                  return (
                                    <Radio value={single.value} index={i}>
                                      {single.label}
                                    </Radio>
                                  );
                                })}
                              </Space>
                            </Radio.Group>
                          </div>
                          <div className="form-group">
                            <label className="mb-2 input-heading">
                              24. Climb a stepstool?
                              <span className="text-danger">*</span>
                            </label>
                            <br />
                            <Radio.Group
                              onChange={(e) =>
                                this.setState({
                                  climb_a_stepstool: e.target.value,
                                })
                              }
                              value={this.state.climb_a_stepstool}
                              direction="vertical"
                            >
                              <Space direction="vertical">
                                {this.state.options.map((single, i) => {
                                  return (
                                    <Radio value={single.value} index={i}>
                                      {single.label}
                                    </Radio>
                                  );
                                })}
                              </Space>
                            </Radio.Group>
                          </div>
                          <div className="form-group">
                            <label className="mb-2 input-heading">
                              25. Get up from the floor?
                              <span className="text-danger">*</span>
                            </label>
                            <br />
                            <Radio.Group
                              onChange={(e) =>
                                this.setState({
                                  give_up_from_the_floor: e.target.value,
                                })
                              }
                              value={this.state.give_up_from_the_floor}
                              direction="vertical"
                            >
                              <Space direction="vertical">
                                {this.state.options.map((single, i) => {
                                  return (
                                    <Radio value={single.value} index={i}>
                                      {single.label}
                                    </Radio>
                                  );
                                })}
                              </Space>
                            </Radio.Group>
                          </div>
                          <div className="form-group">
                            <label className="mb-2 input-heading">
                              26. Carry an object going downstairs?
                              <span className="text-danger">*</span>
                            </label>
                            <br />
                            <Radio.Group
                              onChange={(e) =>
                                this.setState({
                                  carry_an_object_downstairs: e.target.value,
                                })
                              }
                              value={this.state.carry_an_object_downstairs}
                              direction="vertical"
                            >
                              <Space direction="vertical">
                                {this.state.options.map((single, i) => {
                                  return (
                                    <Radio value={single.value} index={i}>
                                      {single.label}
                                    </Radio>
                                  );
                                })}
                              </Space>
                            </Radio.Group>
                          </div>
                          <div className="form-group">
                            <label className="mb-2 input-heading">
                              27. Stand for hours?
                              <span className="text-danger">*</span>
                            </label>
                            <br />
                            <Radio.Group
                              onChange={(e) =>
                                this.setState({
                                  stand_for_hours: e.target.value,
                                })
                              }
                              value={this.state.stand_for_hours}
                              direction="vertical"
                            >
                              <Space direction="vertical">
                                {this.state.options.map((single, i) => {
                                  return (
                                    <Radio value={single.value} index={i}>
                                      {single.label}
                                    </Radio>
                                  );
                                })}
                              </Space>
                            </Radio.Group>
                          </div>
                          <div className="form-group">
                            <label className="mb-2 input-heading">
                              28. Get heavy objects off a high shelf?
                              <span className="text-danger">*</span>
                            </label>
                            <br />
                            <Radio.Group
                              onChange={(e) =>
                                this.setState({
                                  get_heavy_objects_off_high_shelf:
                                    e.target.value,
                                })
                              }
                              value={
                                this.state.get_heavy_objects_off_high_shelf
                              }
                              direction="vertical"
                            >
                              <Space direction="vertical">
                                {this.state.options.map((single, i) => {
                                  return (
                                    <Radio value={single.value} index={i}>
                                      {single.label}
                                    </Radio>
                                  );
                                })}
                              </Space>
                            </Radio.Group>
                          </div>
                          <div className="d-flex mt-5">
                            <button
                              className="submit-button ml-2"
                              style={{
                                marginLeft: 0,
                                padding: "9px 15px 10px 20px",
                              }}
                              onClick={() => this.save_road_session()}
                            >
                              Save{" "}
                              <box-icon
                                name="chevron-right"
                                color="#fff"
                                style={{ position: "relative", top: 1 }}
                              ></box-icon>
                            </button>
                          </div>
                        </div>
                      </Spin>
                    </div>
                  </div>
                </Spin>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}
